export default "__VITE_ASSET__DaHXd2fL__"